type CommentDTO = {
  avatar: string // '/files/8809275/speaker-avatar.png'
  comment_id: number // 8810710
  comment_status: string // ''
  comment_time: string // ''
  comment_type: 'chat' | 'speaker-chat' // 'chat'
  content: string | number // 3
  content_text: string | number // 3
  creation_date_ansi: string // '2025-02-28 17:40:25'
  email: string // 'joao@twentythree.com'
  facebook_link: string // '/live/8809238/facebook?comment_id=8810710'
  first_name: string // 'J'
  full_name: string // 'João Ferreira'
  label: string // 'Speaker'
  name: string // 'J F'
  object_id: number // 8809238
  object_type: string // 'live'
  object_url: string // '/live/8809238'
  pretty_date: string // 'February 28, 2025'
  pretty_time: string // '05:40 PM'
  promoted_p: boolean // false
  reactions: {
    reaction_emoji: string // "🚀"
    count: number // 4
  }[]
  media?: [
    {
      description: string
      provider_name: string
      provider_url: string
      thumbnail_height: number
      thumbnail_url: string
      thumbnail_width: number
      title: string
      type: string
      url: string
      version: number
    },
  ]
  short_date: string // '28. Feb'
  truncated_name: string // 'J F'
  twitter_link: string // '/live/8809238/twitter?comment_id=8810710'
  url: string // ''
  uuid: string // '3899aaab-a634-0499-b559-5ec5da1f6203'

  reply_to_comment_id: number | ''
  reply_to_comment_name: string
  reply_to_comment_full_name: string
  reply_to_comment_label: string
  reply_to_comment_content: string
}

type Comment = {
  id: number
  htmlContent: string
  textContent: string
  name: string
  fullName: string
  pinned: boolean
  label: 'speaker' | 'audience'
  reactions: Map<string, number>
  media?: {
    title: string
    description: string
    url: string
    providerUrl: string
    thumbnailUrl: string
  }
  reply?: {
    commentId: number
    name: string
    fullName: string
    label: 'speaker' | 'audience'
    content: string
  }
  isOptimisticUpdate: boolean
}

const mapDTOtoComment = (dto: CommentDTO): Comment => {
  const media = dto?.media?.at(0)
  return {
    id: dto.comment_id,
    htmlContent: `${dto.content}`,
    textContent: `${dto.content_text}`,
    name: dto.name,
    fullName: dto.full_name,
    pinned: dto.promoted_p,
    label: dto.label.toLowerCase() === 'speaker' ? 'speaker' : 'audience',
    reactions: new Map(dto.reactions.map((r) => [r.reaction_emoji, r.count])),
    media: media && {
      title: media.title,
      description: media.description,
      url: media.url,
      providerUrl: media.provider_url,
      thumbnailUrl: media.thumbnail_url,
    },
    reply: dto.reply_to_comment_id
      ? {
          commentId: dto.reply_to_comment_id,
          name: dto.reply_to_comment_name,
          fullName: dto.reply_to_comment_full_name,
          label:
            dto.reply_to_comment_label.toLowerCase() === 'speaker'
              ? 'speaker'
              : 'audience',
          content: dto.reply_to_comment_content,
        }
      : undefined,
    isOptimisticUpdate: false,
  }
}

export { type CommentDTO, type Comment, mapDTOtoComment }
